import * as Firebase from '../services/firebase.service'
import { makeAutoObservable, when } from 'mobx';
import { App } from './app.store';
import { LoadableStore } from './loadable.store';
import { Auction } from 'nfty-common/lib/model/auction.model';
import { ArtistJsonDataPublic } from 'nfty-common/lib/model/artist.model';
import { PublicRef } from 'nfty-common/lib/model/firebase-schema';

export class AuctionStore implements LoadableStore {

    appStore: any;
    dataLoaded = false;

    auctionData?: Auction;
    artists?: Record<string, ArtistJsonDataPublic>;
    upcomingDate?: Date;

    constructor(appStore: App) {
        this.appStore = appStore;
        appStore.registerStore('auction', this);

        makeAutoObservable(this);

        Firebase.publicRef.on('value', this.onDataChange.bind(this));
    }

    async onDataChange(snapshot: Firebase.DataSnap) {
        try {
            if (snapshot.exists()) {
                const { currentAuction, nextAuctionDate, artists } = snapshot.val() as PublicRef;

                if (currentAuction) {
                    this.setAuctionData(currentAuction);
                    this.setDataLoaded(true);
                } else {
                    this.resetAuction();
                }

                if (nextAuctionDate) {
                    this.setUpcomingDate(nextAuctionDate);
                } else {
                    this.resetUpcomingDate();
                }

                if (artists) {
                    this.setArtists(artists);
                }
            } else {
                this.resetAuction();
                this.resetUpcomingDate();
            }
        } catch {
        } finally {
            this.dataLoaded = true;
        }
    }

    async load() {
        try {
            await when(() => this.dataLoaded);
            return true;
        } catch (error) {
            return false;
        }
    }

    setAuctionData(auction?: Auction) {
        this.auctionData = auction;
    }

    /**
     * @param value The ethereum value of the current bid
     */
    setCurrentBid(value: number) {
        if (this.auctionData) {
            this.auctionData.salePrice = value;
        }
    }

    setUpcomingDate(date: number) {
        this.upcomingDate = new Date(date);
    }

    setDataLoaded(value = true) {
        this.dataLoaded = value;
    }

    resetAuction() {
        this.auctionData = undefined;
    }

    resetUpcomingDate() {
        this.upcomingDate = undefined;
    }

    setArtists(data: Record<string, ArtistJsonDataPublic>) {
        this.artists = data;
    }

    get nftUrl(): string {
        return (this.auctionData?.nftUrl) || `${window.location.host}/token/${this.auctionData?.nftTokenId}`;
    }
}